//
// VAViewerModel.js
// vav
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "@sas-dvr/ltjs-commons/models/BaseModel";

var VAViewerModel = createModule("vav::VAViewerModel", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getDescription: [7,4],
    },
    ,
    ,
]);
export default VAViewerModel;
